
export function createSparkLeft(x, y) {
    let sprite = game.add.sprite(x, y, 'effects', 0, game.effectsGrp);
    sprite.anchor.set(1, 0.5);
    sprite.animations.add('spark', Phaser.Animation.generateFrameNames('spark_l', 1, 8, '.png', 2), 12);
    sprite.animations.play('spark', null, false, true);
    return sprite;
}

export function createSparkRight(x, y) {
    let sprite = game.add.sprite(x, y, 'effects', 0, game.effectsGrp);
    sprite.anchor.set(0, 0.5);
    sprite.animations.add('spark', Phaser.Animation.generateFrameNames('spark_r', 1, 8, '.png', 2), 12);
    sprite.animations.play('spark', null, false, true);
    return sprite;
}

export function createSparkRandom(x, y) {
    if (Math.random() > 0.5) {
        return createSparkLeft(x, y);
    } else {
        return createSparkRight(x, y);
    }
}

export function createExplosion(x, y) {
    game.sounder.play('boom-1');
    let sprite = game.add.sprite(x, y, 'effects', 0, game.effectsGrp);
    sprite.anchor.set(0.5, 0.5);
    sprite.animations.add('explosion', Phaser.Animation.generateFrameNames('explosion', 1, 8, '.png', 2), 12);
    sprite.animations.play('explosion', null, false, true);
    return sprite;
}

export function createFire(x, y) {
    let sprite = game.add.sprite(x, y, 'effects', 0, game.effectsGrp);
    sprite.anchor.set(0.5, 1);
    sprite.animations.add('fire', Phaser.Animation.generateFrameNames('fire_', 1, 5, '.png', 2), 12, true);
    sprite.animations.play('fire');
    return sprite;
}


// WEBPACK FOOTER //
// ./src/states/effects.js